<script>
import {
  REPORT_FILTER_FIELDS,
  EVENT_REPORT_FILTER_FIELDS,
} from '@/utilities/appConsts'
import {
  getDateSelectorStartDateGivenOffset,
  getDateSelectorEndDateGivenOffset,
} from '@/utilities/dates'
import _ from 'lodash'

export default {
  data() {
    return { isInitialized: false }
  },

  methods: {
    initAirlineField() {
      const updatedReportFilterFields = this.reportFilterFields.map(item => {
        if (item.id === 'acmfAirline' && this.mappedAcmfAirlines.length > 0) {
          const mappedAirlineIds =
            this.mappedAcmfAirlines.length === 1
              ? [this.mappedAcmfAirlines[0].value]
              : []
          const airlineIds =
            mappedAirlineIds.length === 1
              ? mappedAirlineIds
              : this.globalFilter
              ? this.globalFilter.airlineIdsSelected || []
              : []

          return {
            ...item,
            selection:
              this.mappedAcmfAirlines.length === 1
                ? [airlineIds[0]]
                : item.selection,
            selectedItems:
              this.mappedAcmfAirlines.length === 1
                ? [
                    {
                      airlineId: airlineIds[0],
                      text: airlineIds[0],
                      value: airlineIds[0],
                    },
                  ]
                : item.selectedItems,
            visible: this.airlines.length === 1 ? false : item.visible,
          }
        }

        if (
          item.id === 'acmfMasterModel' &&
          !this.isInitialized &&
          this.mappedAcmfAirlines.length === 1 &&
          this.mappedAcmfMasterModels.length > 0
        ) {
          const filteredMasterModels = this.mappedAcmfMasterModels
            .filter(
              item => item.airlineId === this.mappedAcmfAirlines[0].airlineId,
            )
            .filter(
              item =>
                this.masterModelIdsSelected.length === 0 ||
                this.masterModelIdsSelected.includes(item.masterModelId),
            )

          const updatedItem = {
            ...item,
            selection:
              this.mappedAcmfAirlines.length === 1
                ? filteredMasterModels.map(item => item.value)
                : item.selection,
            selectedItems:
              this.mappedAcmfAirlines.length === 1
                ? filteredMasterModels
                : item.selectedItems,
          }

          return updatedItem
        }

        if (
          item.id === 'acmfMasterModel' &&
          !this.isInitialized &&
          this.mappedAcmfMasterModels.length > 0
        ) {
          const [airline] = this.reportFilterFields.filter(
            item2 => item2.id === 'acmfAirline',
          )
          if (airline) {
            if (airline.selection.length > 0) {
              const airlineId = airline.selection[0]

              let airlineFilters = []
              if (
                this.globalFilter.isActive &&
                this.globalFilter.selections.length > 0
              ) {
                airlineFilters = this.globalFilter.selections.filter(
                  item3 => item3.airlineId === airlineId,
                )
              } else {
                airlineFilters = this.mappedAcmfMasterModels.filter(
                  item => item.airlineId === airlineId,
                )
              }

              const groupedMasterModels = _.groupBy(
                airlineFilters,
                'masterModelId',
              )
              const masterModelIds = Object.keys(groupedMasterModels).map(key =>
                parseInt(key),
              )
              if (item.selection.length > 0) {
                item.selection = item.selection.filter(item4 =>
                  masterModelIds.includes(item4),
                )
              }
              if (item.selection.length === 0) {
                item.selection = masterModelIds
              }
            }
          }
        }

        return item
      })

      this.reportFilterFields = updatedReportFilterFields
    },

    initReportFilterFields() {
      if (
        this.savedReportFilterFields &&
        this.savedReportFilterFields.length > 0
      ) {
        return
      }

      this.reportFilterFields = REPORT_FILTER_FIELDS.map(item => {
        let updatedSelection = item.selection
        if (item.isDate) {
          const value = item.selection?.value || '3'
          const endDate = item.selection?.endDate || new Date()
          const startDate = item.selection?.startDate || new Date()
          updatedSelection = {
            dates: {
              value,
              startDate: getDateSelectorStartDateGivenOffset(value, startDate),
              endDate: getDateSelectorEndDateGivenOffset(value, endDate),
            },
          }
        }
        return {
          ...item,
          selection: updatedSelection,
          selectedItems: item.selectedItems || [],
          visible: item.visible,
        }
      })
    },

    initEventReportFilterFields() {
      if (
        this.savedEventReportFilterFields &&
        this.savedEventReportFilterFields.length > 0
      ) {
        return
      }

      this.eventReportFilterFields = EVENT_REPORT_FILTER_FIELDS.map(item => {
        let updatedSelection = item.selection
        if (item.isDate) {
          const value = item.selection?.value || '3'
          const endDate = item.selection?.endDate || new Date()
          const startDate = item.selection?.startDate || new Date()
          updatedSelection = {
            dates: {
              value,
              startDate: getDateSelectorStartDateGivenOffset(value, startDate),
              endDate: getDateSelectorEndDateGivenOffset(value, endDate),
            },
          }
        }
        return {
          ...item,
          selection: updatedSelection,
          selectedItems: item.selectedItems || [],
          visible: item.visible,
        }
      })
    },
  },
}
</script>
